import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from '../../components/navbars/navbar/navbar.component';
import { SideMenuComponent } from '../../components/navbars/side-menu/side-menu.component';
import { DataService } from '../../Services/Data Service/data.service';
import { VendorMessagesPulseService } from '../../Services/vendor-messages-pulse.service';
import { AuthService } from '../../Auth/auth.service';
import { filter, take } from 'rxjs';

export interface VendorMessageRow {
  id: number;
  noteContent: string;
  createdAt: string;
  senderName: string | null;
}

@Component({
  selector: 'app-vendor-messages',
  standalone: true,
  imports: [CommonModule, NavbarComponent, SideMenuComponent],
  templateUrl: './vendor-messages.component.html',
  styleUrl: './vendor-messages.component.css',
})
export class VendorMessagesComponent implements OnInit {
  isNavbarExpanded = false;
  loading = true;
  error: string | null = null;
  messages: VendorMessageRow[] = [];

  constructor(
    private dataService: DataService,
    private auth: AuthService,
    private vendorMessagesPulse: VendorMessagesPulseService
  ) {}

  ngOnInit(): void {
    const token = this.auth.getAccessToken();
    const email = this.auth.getUserEmail();
    if (!token || !email) {
      this.loading = false;
      this.error = 'Please sign in to view messages.';
      return;
    }

    this.dataService.currentUser$
      .pipe(
        filter((u): u is NonNullable<typeof u> => u != null),
        take(1)
      )
      .subscribe({
        next: (user) => {
          if (user.role !== 'Vendor') {
            this.loading = false;
            this.error = 'This page is only available to vendor accounts.';
            return;
          }
          this.fetchMessages();
        },
        error: () => {
          this.loading = false;
          this.error = 'Could not verify your account.';
        },
      });
  }

  toggleCollapse(expanded: boolean): void {
    this.isNavbarExpanded = expanded;
  }

  private fetchMessages(): void {
    this.loading = true;
    this.error = null;
    this.dataService.getMyVendorMessages().subscribe({
      next: (rows) => {
        this.messages = Array.isArray(rows) ? rows : [];
        this.vendorMessagesPulse.markViewedForRows(this.messages);
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.error = 'Unable to load messages. Please try again later.';
      },
    });
  }

  formatWhen(iso: string): string {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  }
}
